import PropTypes from "prop-types"
import React from "react"
import { useQuery } from "react-query"

import { queryApi } from "src/utils/api/ApiMethods"

import CurrentPlanPanel from "./CurrentPlanPanel"
import InvoicesTable from "./InvoicesTable"
import PaymentMethodPanel from "./PaymentMethodPanel"
import SubscriptionSkeleton from "./SubscriptionSkeleton"

const MarinaSubscription = ({
  billingDataPath,
  paymentMethodLinkPath,
  paymentMethodsPath,
}) => {
  const { isLoading, isError, data } = useQuery(
    ["marinaSubscription", billingDataPath],
    () => queryApi(billingDataPath),
    { retry: false, refetchOnWindowFocus: false }
  )

  return (
    <div className="mx-auto max-w-5xl px-4 py-6">
      {isLoading && <SubscriptionSkeleton />}

      {isError && (
        <div className="rounded border border-red-200 bg-red-50 p-4 text-red-700">
          We couldn&apos;t load subscription data. Please try reloading the
          page.
        </div>
      )}

      {data && data.unmapped && (
        <div className="bg-gray-50 rounded border border-gray-200 p-6 text-gray-700">
          This marina isn&apos;t billed through Measure yet.
        </div>
      )}

      {data && !data.unmapped && (
        <div className="space-y-6">
          <CurrentPlanPanel subscription={data.subscription} />
          <InvoicesTable invoices={data.invoices} />
          <PaymentMethodPanel
            paymentMethods={data.payment_methods}
            paymentMethodLinkPath={paymentMethodLinkPath}
            paymentMethodsPath={paymentMethodsPath}
          />
        </div>
      )}
    </div>
  )
}

MarinaSubscription.propTypes = {
  billingDataPath: PropTypes.string.isRequired,
  paymentMethodLinkPath: PropTypes.string.isRequired,
  paymentMethodsPath: PropTypes.string.isRequired,
}

export default MarinaSubscription
